/**
 * Part of datavideo-intl project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */

$(() => {
  // subscribe modal
  const loading = $('.c-subscribe .subscribe-submit .spinner-border');
  const subscribeModalForm = $('.c-subscribe .subscribe-modal');
  const subscribeModalBtn = $('.subscribe-modal-submit');

  // subscribeModalBtn.prop('disabled', true);
  subscribeModalForm.submit(false);

  subscribeModalForm.on('submit', async function (event) {
    event.stopPropagation();

    const $form = $(this);

    const router = u.route('subscribe');

    loading.removeClass('d-none');
    subscribeModalBtn.prop('disabled', true);

    try {
      const res = await u.$http.post(
        router,
        new FormData($form[0])
      );

      swal({
        title: 'Subscribed',
        icon: 'success'
      }).then(() => {
        location.reload();
      });
    } catch (e) {
      console.error(e);
    } finally {
      subscribeModalBtn.prop('disabled', false);
    }
  })
});
